import {State} from "@store/state";
import {createSelector} from "@ngrx/store";
import { NOF_CONFIGURE_THRESHOLD_PERMISSION, NOF_TEAMS_CAMPAIGN_PERMISSION } from "@auth/routes/permissions";

const getUserInfos = (state: State) => state.userInfos;

export const getUserAuthorizations = createSelector(
  getUserInfos,
  (state) => state.userAuthorizations
);

export const getIsUserAuthorizedToTeamsCampaign = createSelector(
  getUserAuthorizations,
  (state) => NOF_TEAMS_CAMPAIGN_PERMISSION.some((permission) => state.nofUserRoles.includes(permission))
);

export const getIsUserAuthorizedToConfigureThresholds = createSelector(
  getUserAuthorizations,
  (state) => NOF_CONFIGURE_THRESHOLD_PERMISSION.some((permission) => state.nofUserRoles.includes(permission))
);
